"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  id: 1,
  name: "Sarah Jenkins",
  location: "Atlanta, GA",
  text: "I had a sudden pipe leak at night. The independent pro connected through Handy Heroes responded quickly, stopped the leak, and provided a clear estimate for the repairs. Highly recommend!",
  initials: "SJ"
}, {
  id: 2,
  name: "Michael Chen",
  location: "Marietta, GA",
  text: "Professional and attentive service. We had a persistent hidden leak that was difficult to locate. The plumber used inspection gear to pinpoint it quickly and resolved the issue neatly.",
  initials: "MC"
}, {
  id: 3,
  name: "Emily Rodriguez",
  location: "Alpharetta, GA",
  text: "From the quote request to finishing the project, the process was seamless. The pro gave a clear quote before starting and replaced our corroded pipe section without hassle.",
  initials: "ER"
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};
export default function PlumbingTestimonials() {
  return <section id="plumbingtestimonials" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center mb-12 md:mb-16">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.5
        }}>
            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl mb-4">
              Trusted by Homeowners
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
              Read how Atlanta homeowners connect with local independent plumbers for leak detection, pipe repair, and water systems.
            </p>
          </motion.div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((testimonial, i) => <motion.div key={testimonial.id} variants={itemVariants} data-index={i}>
              <Card className="h-full flex flex-col relative overflow-hidden border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="absolute top-6 right-6 text-primary/10">
                  <Quote className="w-12 h-12" />
                </div>
                <CardHeader className="pb-4">
                  <div className="flex items-center gap-4">
                    <SafeHydrate><Avatar className="w-12 h-12 border-2 border-primary/20">
                      <AvatarImage src={testimonial.image} data-wvc-srcset={testimonial.imageSrcset} data-wvc-sizes={testimonial.imageSizes} alt={`${testimonial.name} profile picture`} />
                      <AvatarFallback className="font-default font-semibold text-primary">
                        {testimonial.initials}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div>
                      <CardTitle className="text-lg">{testimonial.name}</CardTitle>
                      <CardDescription>{testimonial.location}</CardDescription>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="flex-1 flex flex-col pt-4">
                  <p className="text-muted-foreground leading-relaxed flex-1">
                    "{testimonial.text}"
                  </p>
                </CardContent>
              </Card>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}